import React from 'react';
import {useIntl} from 'react-intl';
import DataTable from '../../components/dataTable';
import useStore from '../../hooks/use-store';
import {canSeeAuditFields} from '../../helpers/auth';

const GroupTable = (props) => {
  const intl = useIntl();
  const {store} = useStore();
  const showAuditFields = canSeeAuditFields(store.auth.profile);
  const {
    onPressAdd,
    onPressEdit,
    removeRegister,
    attributes,
    list,
    loading,
    permissions,
  } = props;

  return (
    <DataTable
      add={onPressAdd}
      edit={onPressEdit}
      remove={removeRegister}
      list={list}
      loading={loading}
      attributes={attributes}
      permissions={permissions}
      keyField={'id'}
      confirmText={intl.formatMessage({id: 'groupRemoveConfirm'})}
      headers={[
        {title: 'sharedName', field: 'name', dataSort: true},
        ...(showAuditFields ? [
          {title: 'sharedCreatedBy', field: 'creatorName', dataSort: true},
          {title: 'sharedCreatorEmail', field: 'creatorEmail', dataSort: true},
          {title: 'sharedCreatedAt', field: 'createdAtFormatted', dataSort: true},
          {title: 'sharedUpdatedAt', field: 'updatedAtFormatted', dataSort: true},
        ] : []),
      ]}
    />
  );
};

export default GroupTable;
